// extracted by mini-css-extract-plugin
module.exports = {"list":"ListView_list__g58VX","no-items-text":"ListView_no-items-text__KbfHx"};